export function sessionStorage_getOrNull<T>(storageKey: string): T | null {
  try {
    const data = sessionStorage.getItem(storageKey);
    return data ? (JSON.parse(data) as T) : null;
  } catch (err) {
    window.$app.logger.warn(`Failed to read from sessionStorage: ${storageKey}`, err);
    return null;
  }
}

export function sessionStorage_set<T>(storageKey: string, value: T): void {
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(value));
  } catch (err) {
    window.$app.logger.warn(`Failed to write to sessionStorage: ${storageKey}`, err);
  }
}

export function sessionStorage_remove(storageKey: string): void {
  try {
    sessionStorage.removeItem(storageKey);
  } catch (err) {
    window.$app.logger.warn(`Failed to remove from sessionStorage: ${storageKey}`, err);
  }
}
